var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BlBackdrop",
        {
          attrs: {
            title: "New Package Item",
            label: "Create",
            submitLoading: _vm.submitLoading,
            disabled: _vm.isDisabledSubmit
          },
          on: {
            "backdrop-close": function($event) {
              return _vm.$emit("close-modal")
            },
            "backdrop-action": _vm.onSubmit
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "flex flex-col gap-4 overflow-y-auto",
              style: { width: "40rem", maxHeight: "calc(100vh - 16rem)" }
            },
            [
              _c(
                "div",
                { staticClass: "px-8 flex flex-col gap-4" },
                [
                  _c("BlInputText", {
                    attrs: { input: _vm.nameInput },
                    on: { changed: _vm.inputHandler }
                  }),
                  _vm._v(" "),
                  _c("BlInputText", {
                    attrs: { input: _vm.descriptionInput },
                    on: { changed: _vm.inputHandler }
                  }),
                  _vm._v(" "),
                  _c("BlInputText", {
                    attrs: { input: _vm.standardRetailPriceInput },
                    on: { changed: _vm.inputHandler }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "w-full h-5 flex-shrink-0 bg-grey-100"
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "px-8 flex flex-col gap-4" },
                [
                  _c(
                    "div",
                    { staticClass: "flex flex-col gap-2" },
                    [
                      _c("BlTextSubtitle1", { attrs: { text: "Provider" } }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: {
                          text:
                            "Specify which therapists can provide this service. You can choose to make it available for everyone or limit it to selected therapists for more control over credit usage."
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.providerOptions, function(opt) {
                    return _c(
                      "div",
                      {
                        key: opt.value,
                        staticClass: "flex gap-4 cursor-pointer",
                        on: {
                          click: function($event) {
                            _vm.providerInput = opt.value
                          }
                        }
                      },
                      [
                        _c("BlInputRadio", {
                          attrs: {
                            checked: _vm.providerInput === opt.value,
                            name: "provider"
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", { attrs: { text: opt.label } })
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm.providerInput === "restricted"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "py-2 px-2 flex flex-col gap-2 bg-slate-200 rounded"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flex items-center justify-between"
                            },
                            [
                              _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    _vm.usersInput.length +
                                    " therapist(s) selected"
                                }
                              }),
                              _vm._v(" "),
                              _c("BlInputButton", {
                                attrs: {
                                  type: "outlined",
                                  dense: "",
                                  label: "Add therapist"
                                },
                                on: {
                                  clicked: function($event) {
                                    _vm.usersMultiSelectOpened = true
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.usersInput.length
                            ? _c(
                                "div",
                                { staticClass: "flex flex-col" },
                                _vm._l(_vm.usersInput, function(user) {
                                  return _c(
                                    "div",
                                    {
                                      key: user.id,
                                      staticClass:
                                        "py-2 flex items-center justify-between gap-4 border-b border-slate-400"
                                    },
                                    [
                                      !user.name
                                        ? _c("BlTextSubtitle3", {
                                            staticClass: "truncate italic",
                                            attrs: {
                                              title: "Deleted user",
                                              text: "Deleted user"
                                            }
                                          })
                                        : _c("BlTextSubtitle3", {
                                            staticClass: "truncate",
                                            attrs: {
                                              title: user.name,
                                              text: user.name
                                            }
                                          }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        attrs: { text: user.email }
                                      })
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ],
                2
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.usersMultiSelectOpened
        ? _c("UsersMultiSelect", {
            attrs: { list: _vm.usersInput },
            on: {
              change: function($event) {
                _vm.usersInput = $event
              },
              "close-modal": function($event) {
                _vm.usersMultiSelectOpened = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-680e0314", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-680e0314","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/center/packageItem/NewPackageItemModal.vue
// module id = null
// module chunks = 